var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmedicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "98px",
    height: "98px",
    viewBox: "0 0 98 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7CD5B9D2-F6A2-43FC-8708-F79FFB26AE67") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.9399993,24.5324085 L61.9399993,24.5324085 C60.9206983,24.6693974 60.0170559,25.2570065 59.4789819,26.1327277 L39.1711335,57.3043354 L30.1328837,50.8456922 L30.1328837,50.8456922 C29.1459719,50.027348 27.783855,49.8292103 26.604364,50.3324228 C25.4248729,50.8356354 24.6261343,51.9556705 24.5352575,53.2338375 C24.4443807,54.5120045 25.0766308,55.7336015 26.173081,56.398345 L38.1534642,64.9379967 C38.919241,65.478919 39.8735161,65.68247 40.7936232,65.501154 C41.7137303,65.319838 42.5191834,64.7695155 43.0220417,63.9785964 L65.2721733,29.8160336 L65.2721733,29.8160336 C66.0221527,28.6967581 66.0438719,27.2416712 65.3276321,26.1005492 C64.6113923,24.9594272 63.2909042,24.3452997 61.9558385,24.5324085 L61.9399993,24.5324085 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FLOW---MOBILE/DESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ThankYouPage",
    transform: "translate(-139.000000, -145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Big-/-Upload",
    transform: "translate(139.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.083333, 4.083333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_13601-path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#059881",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#059881",
    strokeWidth: 1.6,
    cx: 44.9166667,
    cy: 44.9166667,
    r: 44.9166667
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedicon);
export default __webpack_public_path__ + "static/media/confirmed.icon.00f6c5cd53a508a9796a50683efe6b5e.svg";
export { ForwardRef as ReactComponent };